export const DEFAULT_PADDING = 6;
export const DEFAULT_POSITION = 'bottom';
export const DEFAULT_ALIGN = 'end';
